import GastroCartellaInfermieristicaEdit from "./pages/GastroCartellaInfermieristicaEdit.vue"
import GastroCartellaInfermieristicaView from "./pages/GastroCartellaInfermieristicaView.vue"
import GastroCartellaInfermieristicaList from "./pages/GastroCartellaInfermieristicaList.vue"

export default{
    GastroCartellaInfermieristicaEdit,
    GastroCartellaInfermieristicaView,
    GastroCartellaInfermieristicaList
}